import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {cn} from '../lib/cn';

export interface BetaBadgeProps extends React.ComponentProps<'div'> {
  text?: string;
  readOnly?: boolean;
}

export function BetaBadge({
  className,
  children,
  text,
  readOnly = false,
  ...props
}: BetaBadgeProps) {
  const {t} = useTranslation();

  return (
    <div
      data-slot="beta-badge"
      className={cn(
        'rounded-sm bg-[var(--beta-badge-bg)] px-2 py-1 text-sm/4 font-semibold uppercase text-[var(--beta-badge-text)]',
        readOnly &&
          'bg-[var(--beta-badge-readonly-bg)] text-[var(--beta-badge-readonly-text)]',
        className,
      )}
      {...props}
    >
      {text || t('beta')}
      {children}
    </div>
  );
}

BetaBadge.displayName = 'BetaBadge';
